export default "__VITE_ASSET__CGXcJHdr__"